/** @format */
import { css } from 'styled-components';

/** @format */

export const baseStyles = css`
    position: relative;
    display: block;
`;

/**
 * The form container component styles
 *
 * @param {SelectProps} props The select properties object
 */
export const styles = css`
    ${baseStyles}
`;
